import endpoints from '@/utils/endpoints.js'
import axios from '@/utils/init-axios.js'
const defaultPage = 1
const defaultPageSize = 10

export default {
  getMerchantCount({ commit }) {
    return new Promise((resolve, reject) => {
      axios
        .get(endpoints.listMerchantOrganizations())
        .then(res => {
          const numMerchants = res.data.count
          commit('setNumMerchants', { numMerchants })
          resolve(res)
        })
        .catch(err => {
          reject(err)
        })
    })
  },
  // TODO Needs to be set on refresh
  getMerchant({ commit }, { merchantID }) {
    if (merchantID) {
      return new Promise((resolve, reject) => {
        axios
          .get(endpoints.retrieveMerchantOrganization(merchantID))
          .then(res => {
            const merchant = res.data
            commit('setCurrentMerchant', { merchant })
            resolve(res)
          })
          .catch(err => {
            reject(err)
          })
      })
    } else {
      return new Promise((resolve, reject) => {
        axios
          .get(endpoints.listMerchantOrganizations())
          .then(res => {
            const merchants = res.data.results
            if (res.data.count > 0) {
              commit('setCurrentMerchant', { merchant: merchants[0] })
            }
            resolve(res)
          })
          .catch(err => {
            reject(err)
          })
      })
    }
  },
  getMerchantPage(
    { commit },
    { page = defaultPage, pageSize = defaultPageSize }
  ) {
    commit('setMerchantLoading', true)
    return new Promise((resolve, reject) => {
      axios
        .get(endpoints.listMerchantOrganizations(), {
          params: { page: page, page_size: pageSize }
        })
        .then(res => {
          const numMerchants = res.data.count
          const merchants = res.data.results
          commit('setNumMerchants', { numMerchants })
          commit('setMerchantPage', { merchants })
          resolve(res)
        })
        .catch(err => {
          reject(err)
        })
    })
  },
  getMerchantReportURL({ commit, state }, { reportType }) {
    commit('setTransactionReportURL', { reportURL: '' })
    return new Promise((resolve, reject) => {
      axios
        .get(endpoints.listtransaction_report_urls(), {
          params: {
            merchant_id: state.currentMerchant.id,
            report_type: reportType
          }
        })
        .then(res => {
          const reportURL = res.data.url
          console.log(reportURL)
          commit('setTransactionReportURL', { reportURL })
          resolve(res)
        })
        .catch(err => {
          reject(err)
        })
    })
  },
  getCustomerPage(
    { commit, state },
    { page = defaultPage, pageSize = defaultPageSize }
  ) {
    commit('setCustomerLoading', true)
    if (state.currentMerchant) {
      return new Promise((resolve, reject) => {
        axios
          .get(endpoints.listCustomers(state.currentMerchant.id), {
            params: { page: page, page_size: pageSize }
          })
          .then(res => {
            const customers = res.data.results
            const numCustomers = res.data.count
            commit('setNumCustomers', { numCustomers })
            commit('setCustomerPage', { customers })
            resolve(res)
          })
          .catch(err => {
            reject(err)
          })
      })
    }
  },
  getAccountPage(
    { commit, state },
    { page = defaultPage, pageSize = defaultPageSize }
  ) {
    if (state.currentMerchant) {
      return new Promise((resolve, reject) => {
        axios
          .get(endpoints.listAccounts(state.currentMerchant.id), {
            params: { page: page, page_size: pageSize }
          })
          .then(res => {
            const accounts = res.data.results
            const numAccounts = res.data.count
            commit('setNumAccounts', { numAccounts })
            commit('setAccountPage', { accounts })
            resolve(res)
          })
          .catch(err => {
            reject(err)
          })
      })
    }
  },
  setPageTitle({ commit, state }, { pageTitle }) {
    commit('setPageTitle', { pageTitle })
  }
}
